import React, {useEffect, useState } from 'react';
import { getUser, resetUserSession } from "../../../../service/AuthService";
import { useNavigate } from "react-router-dom";
import Image1 from "../..//../../assets/images/accessories/01.png";
import Image2 from "../..//../../assets/images//accessories/02.jpg";
import Image3 from "../..//../../assets/images//accessories/03.png";
import Image4 from "../..//../../assets/images//accessories/04.png";
import Image5 from "../..//../../assets/images//accessories/05.png";
import Image6 from "../..//../../assets/images//accessories/05.png";
import Image7 from "../..//../../assets/images//accessories/01.png";
import UserNavBar from '../../../nav-bar/UserNavBar';
import ProductList from '../../../products/ProductList';


const HomePage = () => {
      const [products, setProducts] = useState([
        {
          id: 1,
          name: "HeadPhone",
          price: "N 5000",
          description:
            "Necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with",
          image: Image1,
          status: "New",
        },
        {
          id: 2,
          name: "HeadPhone",
          price: "N 5000",
          description:
            "Necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with",
          image: Image2,
          status: "New",
        },

        {
          id: 3,
          name: "HeadPhone",
          price: "N 5000",
          description:
            "Necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with",
          image: Image3,
          status: "New",
        },
        {
          id: 4,
          name: "HeadPhone",
          price: "N 5000",
          description:
            "Necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with",
          image: Image4,
          status: "New",
        },
        {
          id: 5,
          name: "HeadPhone",
          price: "N 5000",
          description:
            "Necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with",
          image: Image5,
          status: "New",
        },
        {
          id: 6,
          name: "HeadPhone",
          price: "N 5000",
          description:
            "Necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with",
          image: Image6,
          status: "New",
        },
        {
          id: 7,
          name: "HeadPhone",
          price: "N 5000",
          description:
            "Necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with",
          image: Image7,
          status: "New",
        },
      ]);
  
  const user = getUser();
  const name = user !== "undefined" && user ? user.name : "";
   
  let navigate = useNavigate();

  const handleSignOut = () => {
    resetUserSession();
    navigate("/signin");
    console.log("first");
  }
  useEffect(() => {
    
    return () => {
    
    };
  }, [])
  return (
    <div>
      <div className="page-container">
        <div className='container'>
          <UserNavBar UserName={name} handleSignOutProp={handleSignOut} />
        </div>{" "}
        <ProductList products={products} />
      </div>
    </div>
  );
}

export default HomePage